import React, { useEffect, useRef, useState } from "react";
import styles from "./Nav.module.css";
import {
  PatternlibStorytabs,
  PatternlibStorytabsItem,
  PatternlibOverlayContainer,
  PatternlibIcon,
  PatternlibTextlink,
  PatternlibButton,
} from "@liebherr/patternlib-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BackButton from "../../components/back-button/BackButton";
import useMutationObserver from "../../hooks/useMutationObserver";
import Separator from "../separator/Separator";

function Nav({ partkey, projectPath, activeTab = 0, isDemoUser }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const storytabsRef = useRef();
  const keyRef = useRef();
  const projectPathRef = useRef();
  const overlayRef = useRef();

  // use mutation observer to get current screen size
  const options = {
    config: { attributes: true, childList: true, subtree: true },
  };
  const target = document.documentElement;
  const attributeName = "breakpoint";
  const screen = useMutationObserver(options, target, attributeName);

  const onChangeListener = (event) => {
    console.log(activeTab);
    if (activeTab !== event.detail.itemId) {
      navigateToID(event.detail.itemId);
    }
  };

  useEffect(() => {
    if (partkey !== undefined) {
      keyRef.current = partkey;
    }
  }, [partkey]);

  useEffect(() => {
    if (projectPath !== undefined) {
      projectPathRef.current = projectPath;
    }
  }, [projectPath]);

  const onConfirm = () => {
    setShow(false);
    navigate("/");
  };

  const onClose = () => {
    setShow(false);
    const storytabs = storytabsRef.current;
    storytabs.setStorytabsItemToActive(parseInt(activeTab));
  };

  useEffect(() => {
    if (show) {
      const ref = overlayRef.current;
      const element = ref.shadowRoot.querySelector(".backdrop");
      const content = ref.shadowRoot.querySelector(".content");
      content.style.zIndex = "9999";

      if (element !== null) {
        element.addEventListener("click", onClose, false);

        return () => {
          element.removeEventListener("click", onClose, true);
        };
      }
    }
  }, [show]);

  const navigateToID = (pageID) => {
    switch (pageID) {
      case 0:
        // show modal
        activeTab == 0 ? setShow(false) : setShow(true);
        break;
      case 1:
        navigate("/" + projectPathRef.current, {
          state: { key: keyRef.current },
        });
        break;
      case 2:
        navigate("/summary/" + projectPathRef.current, {
          state: { key: keyRef.current },
        });
        break;
      default:
        navigate("/");
    }
  };

  return (
    <nav>
      {activeTab != 0 && (
        <>
          <BackButton isDemoUser={isDemoUser} />
          <Separator space="s"></Separator>
        </>
      )}
      <PatternlibStorytabs
        width={screen === "isMobile" ? "100%" : "33.3%"}
        container-width="100%"
        direction={screen === "isMobile" ? "vertical" : "horizontal"}
        ref={storytabsRef}
        onLhChangeItem={(e) => onChangeListener(e)}
      >
        <PatternlibStorytabsItem
          active={activeTab == 0 ? true : false}
          label={t("configurator.start")}
        ></PatternlibStorytabsItem>
        <PatternlibStorytabsItem
          active={activeTab == 1 ? true : false}
          label={t("configurator.configuration")}
          disabled={activeTab == 0 ? true : false}
        ></PatternlibStorytabsItem>
        <PatternlibStorytabsItem
          active={activeTab == 2 ? true : false}
          label={t("configurator.summary")}
          disabled={activeTab == 0 ? true : false}
        ></PatternlibStorytabsItem>
      </PatternlibStorytabs>
      <PatternlibOverlayContainer
        target="center"
        show={show}
        disable-click-handlers
        ref={overlayRef}
      >
        <div slot="content" className={styles.modalContent}>
          <div className={styles.modalHeader}>
            <h2>{t("GoBackModal.preventGoingBackTitle")}</h2>
            <div className={styles.closeIcon}>
              <PatternlibIcon icon-name="x" onClick={onClose}></PatternlibIcon>
            </div>
          </div>
          <span>{t("GoBackModal.preventGoingBackText")}</span>
          <div className={styles.modalFooter}>
            <PatternlibTextlink
              label={t("GoBackModal.cancelButton")}
              size="small"
              onClick={onClose}
            ></PatternlibTextlink>
            <PatternlibButton
              label-text-align="left"
              icon-position="right"
              label={t("GoBackModal.preventGoingBackConfirmButton")}
              size="small"
              onClick={onConfirm}
            ></PatternlibButton>
          </div>
        </div>
      </PatternlibOverlayContainer>
    </nav>
  );
}

export default Nav;
